module.exports = __webpack_public_path__ + "img/de-de.ed514ece.svg";